export const MemberRoute = {
  MEMBER: {
    path: 'members',
    name: 'members'
  }
};
